export default __webpack_public_path__ + "static/media/CICHY.bf2b16dc.jpg";